"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAppDeploymentLogs = void 0;
const getAppDeploymentLogs = ({ httpClient, }) => ({ app_id, component_name, deployment_id, follow, pod_connection_timeout, type, }) => {
    const path = '/apps';
    const url = `${path}/${app_id}/deployments/${deployment_id}/components/${component_name}/logs`;
    const query_params = { follow, pod_connection_timeout, type };
    return httpClient.get(url, { params: query_params });
};
exports.getAppDeploymentLogs = getAppDeploymentLogs;
//# sourceMappingURL=get-app-deployment-logs.js.map